import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';

const QuickstartPage = ({ pageNum, activePage, children }) => (
  <div
    className={`onboarding-quickstart-page${activePage === pageNum ? '' : ' is-hidden'}`}
    aria-hidden={activePage !== pageNum}
  >
    {children}
  </div>
);

const OnboardingQuickstartModal = ({ page, setPage, onClose, loggedOutDashboard = false }) => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        .onboarding-quickstart-overlay {
          overflow-y: auto;
        }
        .onboarding-quickstart-dialog {
          display: flex;
          flex-direction: column;
          max-height: calc(100vh - 3rem);
          margin-top: auto;
          margin-bottom: auto;
        }
        .onboarding-quickstart-body {
          flex: 1 1 auto;
          min-height: 0;
          overflow-y: auto;
          -webkit-overflow-scrolling: touch;
        }
        .onboarding-quickstart-pages {
          display: grid;
        }
        .onboarding-quickstart-page {
          grid-area: 1 / 1;
        }
        .onboarding-quickstart-page.is-hidden {
          visibility: hidden;
          pointer-events: none;
        }
        .onboarding-quickstart-header,
        .onboarding-quickstart-footer {
          flex-shrink: 0;
        }
        @media (min-width: 769px) and (min-height: 720px) {
          .onboarding-quickstart-dialog {
            zoom: 1.2;
          }
          .quickstart-nav-btn {
            padding: 8px 18px !important;
            font-size: 14px !important;
          }
        }
        @media (max-width: 768px) {
          .quickstart-nav-btn {
            padding: 12px 22px !important;
            font-size: 15px !important;
          }
        }
      `}</style>
    <div
      className="onboarding-quickstart-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Quick Start guide"
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 2000,
        display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
        padding: '1.5rem',
        fontFamily: 'Nunito, sans-serif'
      }}
    >
      <div
        className="onboarding-quickstart-dialog"
        style={{
          background: '#fff',
          borderRadius: '14px',
          width: '100%',
          maxWidth: '500px',
          overflow: 'hidden',
          boxShadow: '0 6px 28px rgba(0,0,0,0.13)'
        }}
      >
        {/* Header */}
        <div
          className="onboarding-quickstart-header"
          style={{
            background: '#f5f0e6',
            borderBottom: '1px solid #e4dcc8',
            padding: '12px 20px',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div
              style={{
                width: '28px', height: '28px', background: '#c8981e',
                borderRadius: '5px', display: 'flex', alignItems: 'center',
                justifyContent: 'center', fontSize: '8px', fontWeight: '800',
                color: '#fff', letterSpacing: '0.02em'
              }}
            >PXC</div>
            <span style={{ fontSize: '13px', fontWeight: '700', color: '#333' }}>PedalxChange</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <span style={{ fontSize: '10px', color: '#aaa', fontWeight: '600', letterSpacing: '0.05em', textTransform: 'uppercase' }}>Quick Start</span>
            <button type="button" onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '18px', color: '#aaa', lineHeight: 1, padding: '2px' }} aria-label="Close">×</button>
          </div>
        </div>

        {/* Body — all pages mount together so height matches the tallest slide */}
        <div className="onboarding-quickstart-body" style={{ padding: '22px 22px 16px' }}>
          <div className="onboarding-quickstart-pages">

          <QuickstartPage pageNum={1} activePage={page}>
            <div>
              <p style={{ fontSize: '12px', fontWeight: '700', color: '#c8981e', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '5px' }}>Welcome</p>
              <h2 style={{ fontSize: '20px', fontWeight: '800', color: '#222', lineHeight: 1.2, marginBottom: '9px' }}>
                {loggedOutDashboard
                  ? <>Once you sign up,<br />here&apos;s what to do.</>
                  : <>You&apos;re in.<br />Here&apos;s what to do next.</>}
              </h2>
              <p style={{ fontSize: '13px', color: '#555', lineHeight: 1.65 }}>Four steps to discovering that new favorite pedal. The next pages walk you through each step.</p>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '9px', marginTop: '13px' }}>
                {[
                  { n: 1, title: 'List a pedal', desc: 'Makes you visible to every trader on PXC.' },
                  { n: 2, title: 'Build your Wantlist', desc: 'Heart pedals you want. We tell the owner, and tell you when one is listed.' },
                  { n: 3, title: 'Make or receive offers', desc: 'Browse and offer directly. Most trades start here.' },
                  { n: 4, title: 'Enjoy new tones', desc: 'Buy labels in-app, ship safely, leave feedback.' },
                ].map(({ n, title, desc }) => (
                  <div key={n} style={{ background: '#faf8f3', border: '1px solid #e8e0c8', borderRadius: '9px', padding: '11px 12px' }}>
                    <div style={{ width: '20px', height: '20px', borderRadius: '50%', background: '#c8981e', color: '#fff', fontSize: '10px', fontWeight: '800', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '6px' }}>{n}</div>
                    <div style={{ fontSize: '12px', fontWeight: '800', color: '#222', marginBottom: '3px' }}>{title}</div>
                    <div style={{ fontSize: '11px', color: '#777', lineHeight: 1.4 }}>{desc}</div>
                  </div>
                ))}
              </div>
            </div>
          </QuickstartPage>

          <QuickstartPage pageNum={2} activePage={page}>
            <div>
              <p style={{ fontSize: '10px', fontWeight: '700', color: '#c8981e', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '5px' }}>Step 1</p>
              <h2 style={{ fontSize: '20px', fontWeight: '800', color: '#222', lineHeight: 1.2, marginBottom: '9px' }}>List a pedal</h2>
              <p style={{ fontSize: '13px', color: '#555', lineHeight: 1.65 }}>Go to <span style={{ color: '#a07010', fontWeight: '700' }}>My Pedals → Add a New Pedal</span>. Once active, you appear in other traders&apos; searches and can send trade offers of your own. If someone already has your pedal on their Wantlist, they show up under <span style={{ color: '#4a8fd4', fontWeight: '700' }}>Trade Opportunities</span>.</p>
              <div style={{ background: '#faf8f3', border: '1px solid #e4dcc8', borderRadius: '10px', padding: '13px', marginTop: '13px' }}>
                <div style={{ fontSize: '9px', fontWeight: '700', color: '#c8981e', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '10px' }}>Trade Opportunities looks like this</div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  {[
                    { user: 'wiscomike44', pedal: 'Port City Amps Sahana Drive', condition: 'Excellent', price: '$195', wants: 'Wants 5 of your pedals' },
                    { user: 'RCSloan85', pedal: 'EarthQuaker Devices Afterneath', condition: 'Excellent', price: '$130', wants: 'Wants: Lizard Queen' },
                  ].map(({ user: u, pedal, condition, price, wants }) => (
                    <div key={u} style={{ flex: 1, background: '#fff', border: '1px solid #e4dcc8', borderRadius: '8px', overflow: 'hidden', textAlign: 'center' }}>
                      <div style={{ padding: '8px 8px 4px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '3px' }}>
                        <div style={{ width: '28px', height: '28px', borderRadius: '50%', background: '#d8d0c0' }} />
                        <div style={{ fontSize: '9px', color: '#555', fontWeight: '600' }}>{u}</div>
                      </div>
                      <div style={{ fontSize: '10px', fontWeight: '800', color: '#222', padding: '0 6px 4px', lineHeight: 1.3 }}>{pedal}</div>
                      <div style={{ position: 'relative', margin: '0 6px 6px' }}>
                        <div style={{ background: '#ddd4b8', height: '60px', borderRadius: '6px', width: '100%' }} />
                        <div style={{ position: 'absolute', bottom: '4px', left: '4px', background: '#2a8a2a', color: '#fff', fontSize: '7px', fontWeight: '700', borderRadius: '4px', padding: '2px 5px' }}>Potential Match</div>
                      </div>
                      <div style={{ fontSize: '9px', color: '#555', lineHeight: 1.5, padding: '0 6px 4px' }}>Condition: {condition}<br />Price: {price}</div>
                      <div style={{ fontSize: '9px', fontWeight: '800', color: '#c8981e', padding: '0 6px 7px' }}>{wants}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </QuickstartPage>

          <QuickstartPage pageNum={3} activePage={page}>
            <div>
              <p style={{ fontSize: '10px', fontWeight: '700', color: '#c8981e', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '5px' }}>Step 2</p>
              <h2 style={{ fontSize: '20px', fontWeight: '800', color: '#222', lineHeight: 1.2, marginBottom: '9px' }}>Build your Wantlist</h2>
              <p style={{ fontSize: '13px', color: '#555', lineHeight: 1.65 }}>Tap the <span style={{ color: '#a07010', fontWeight: '700' }}>heart</span> on any pedal, hit <span style={{ color: '#a07010', fontWeight: '700' }}>Save to Wantlist</span> on a listing, or type one in on your Wantlist page. We notify you when one gets listed, and they show up under <span style={{ color: '#4a8fd4', fontWeight: '700' }}>Saved Pedals</span> on your dashboard. If your Wantlist ever overlaps with someone&apos;s Pedalboard, we&apos;ll show you the trade match.</p>
              <div style={{ background: '#faf8f3', border: '1px solid #e4dcc8', borderRadius: '10px', padding: '13px', marginTop: '13px' }}>
                <div style={{ fontSize: '9px', fontWeight: '700', color: '#c8981e', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '10px' }}>Three ways to save a pedal</div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '7px' }}>
                  {[
                    { brand: 'Strymon', model: 'Deco', price: '$175', how: 'Heart on a card' },
                    { brand: 'ProCo', model: 'Rat2', price: '$99', how: 'Button on a listing' },
                    { brand: 'Eventide', model: 'Blackhole', price: '$199', how: 'Add Want in My Pedals' },
                  ].map(({ brand, model, price, how }, i) => (
                    <div key={brand} style={{ background: '#fff', border: '1px solid #e4dcc8', borderRadius: '7px', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                      {i === 2 ? (
                        // Mirrors the real Add Want form: the Add Pedal / Add Want toggle and
                        // the "Search for your pedal" field.
                        <div style={{ padding: '6px 6px 0', height: '52px', boxSizing: 'border-box' }}>
                          <div style={{ display: 'flex', background: '#fff', border: '1px solid #e4dcc8', borderRadius: '20px', padding: '2px', marginBottom: '5px' }}>
                            <div style={{ flex: 1, textAlign: 'center', fontSize: '6px', fontWeight: '700', padding: '2px 0', color: '#888', whiteSpace: 'nowrap' }}>Add Pedal</div>
                            <div style={{ flex: 1, textAlign: 'center', fontSize: '6px', fontWeight: '700', padding: '2px 0', borderRadius: '16px', color: '#fff', background: '#c8981e', whiteSpace: 'nowrap' }}>Add Want</div>
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '3px', border: '1px solid #374151', borderRadius: '12px', padding: '3px 5px', background: '#fff' }}>
                            <span style={{ fontSize: '8px', color: '#9CA3AF', lineHeight: 1 }}>&#9906;</span>
                            <span style={{ fontSize: '7px', color: '#9CA3AF', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Search for your pedal</span>
                          </div>
                        </div>
                      ) : (
                      <div style={{ position: 'relative' }}>
                        <div style={{ background: '#ddd4b8', height: '52px', width: '100%' }} />
                        {i === 0 && (
                          <div style={{ position: 'absolute', bottom: '3px', right: '3px', background: 'rgba(255,255,255,0.95)', color: '#c8981e', fontSize: '9px', fontWeight: '800', borderRadius: '10px', padding: '2px 6px', lineHeight: 1.2, boxShadow: '0 1px 3px rgba(0,0,0,0.2)' }}>&#9829; 12</div>
                        )}
                      </div>
                      )}
                      <div style={{ padding: '5px 6px 6px', display: 'flex', flexDirection: 'column', flex: 1 }}>
                        <div style={{ fontSize: '9px', fontWeight: '800', color: '#222', lineHeight: 1.2 }}>{brand}</div>
                        <div style={{ fontSize: '8px', color: '#777', lineHeight: 1.2 }}>{model}</div>
                        <div style={{ fontSize: '9px', color: '#555', marginTop: '2px' }}>{price}</div>
                        {i === 1 && (
                          // Mirrors the real listing-page button: white pill, grey border, dark text.
                          <div style={{ marginTop: '5px', border: '1px solid #9CA3AF', borderRadius: '9999px', background: '#fff', color: '#374151', fontSize: '7px', fontWeight: '600', padding: '3px 6px', textAlign: 'center', lineHeight: 1.2 }}>Save to Wantlist</div>
                        )}
                        <div style={{ fontSize: '8px', color: '#a07010', fontWeight: '700', marginTop: 'auto', paddingTop: '4px', lineHeight: 1.3, minHeight: '21px' }}>{how}</div>
                      </div>
                    </div>
                  ))}
                </div>
                <div style={{ fontSize: '10px', color: '#666', textAlign: 'center', marginTop: '10px', fontStyle: 'italic' }}>Saved pedals that get listed show up under Saved Pedals on your dashboard.</div>
              </div>
            </div>
          </QuickstartPage>

          <QuickstartPage pageNum={4} activePage={page}>
            <div>
              <p style={{ fontSize: '10px', fontWeight: '700', color: '#c8981e', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '5px' }}>Step 3</p>
              <h2 style={{ fontSize: '20px', fontWeight: '800', color: '#222', lineHeight: 1.2, marginBottom: '9px' }}>Making an offer</h2>
              <p style={{ fontSize: '13px', color: '#555', lineHeight: 1.65 }}>Open any listing, hit <span style={{ color: '#a07010', fontWeight: '700' }}>Propose a trade</span>. Pick your pedal(s), choose straight trade or add cash either way. Once accepted: exchange cash if needed, buy labels in-app, leave feedback.</p>
              <div style={{ display: 'flex', gap: '8px', marginTop: '13px', marginBottom: '9px' }}>
                <div style={{ flex: 1, background: '#faf8f3', border: '1px solid #e4dcc8', borderRadius: '8px', padding: '9px' }}>
                  <div style={{ fontSize: '9px', fontWeight: '700', color: '#888', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '6px' }}>Their pedal</div>
                  <div style={{ background: '#ddd4b8', height: '58px', borderRadius: '6px', marginBottom: '5px' }} />
                  <div style={{ fontSize: '10px', fontWeight: '800', color: '#222', marginBottom: '1px' }}>Gamechanger Plasma Coil</div>
                  <div style={{ fontSize: '9px', color: '#777' }}>Excellent · $300</div>
                </div>
                <div style={{ flex: 1, background: '#faf8f3', border: '1px solid #e4dcc8', borderRadius: '8px', padding: '9px' }}>
                  <div style={{ fontSize: '9px', fontWeight: '700', color: '#888', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '6px' }}>Your pedals</div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px' }}>
                    {[true, false, false, false].map((filled, i) => (
                      <div key={i} style={{ height: '34px', borderRadius: '5px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', background: filled ? '#ddd4b8' : 'none', border: filled ? 'none' : '1px dashed #ccc4a0', color: filled ? 'inherit' : '#bbb' }}>
                        {filled ? '' : '+'}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '5px', marginBottom: '9px' }}>
                {[
                  { label: 'Straight trade', sub: 'No cash involved', on: true },
                  { label: 'Ask for additional $', sub: 'They pay you', on: false },
                  { label: 'Offer additional $', sub: 'You pay them', on: false },
                ].map(({ label, sub, on }) => (
                  <div key={label} style={{ display: 'flex', alignItems: 'center', gap: '7px', padding: '6px 9px', background: '#faf8f3', border: '1px solid #e4dcc8', borderRadius: '6px' }}>
                    <div style={{ width: '11px', height: '11px', borderRadius: '50%', border: on ? '1.5px solid #4a8fd4' : '1.5px solid #bbb', background: on ? '#4a8fd4' : 'none', flexShrink: 0 }} />
                    <span style={{ fontSize: '11px', fontWeight: '700', color: '#222' }}>{label}</span>
                    <span style={{ fontSize: '10px', color: '#999', marginLeft: 'auto' }}>{sub}</span>
                  </div>
                ))}
              </div>
            </div>
          </QuickstartPage>

          <QuickstartPage pageNum={5} activePage={page}>
            <div>
              <p style={{ fontSize: '10px', fontWeight: '700', color: '#c8981e', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '5px', textAlign: 'center' }}>Step 4</p>
              <h2 style={{ fontSize: '20px', fontWeight: '800', color: '#222', lineHeight: 1.2, marginBottom: '9px', textAlign: 'center' }}>Complete the trade</h2>
              <p style={{ fontSize: '13px', color: '#555', lineHeight: 1.65, marginBottom: '0', textAlign: 'center' }}>Once accepted, a step-by-step checklist guides both traders to the finish line. Send or receive cash via Stripe, purchase a discounted fully insured shipping label, then leave feedback and enjoy your new pedal.</p>
              <div style={{ background: '#faf8f3', border: '1px solid #e4dcc8', borderRadius: '10px', padding: '13px', marginTop: '13px' }}>
                <div style={{ fontSize: '9px', fontWeight: '700', color: '#c8981e', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '10px' }}>Trade progress looks like this</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', padding: '10px 0', borderBottom: '1px solid #e8e0c8' }}>
                    <div style={{ width: '22px', height: '22px', borderRadius: '50%', background: '#2a8a2a', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: '1px' }}>
                      <span style={{ color: '#fff', fontSize: '12px', fontWeight: '800' }}>✓</span>
                    </div>
                    <div>
                      <div style={{ fontSize: '12px', fontWeight: '800', color: '#222', marginBottom: '2px' }}>Completed Payment</div>
                      <div style={{ fontSize: '11px', color: '#777', lineHeight: 1.4 }}>Send or receive cash difference via Stripe, fast and secure.</div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', padding: '10px 0', borderBottom: '1px solid #e8e0c8' }}>
                    <div style={{ width: '22px', height: '22px', borderRadius: '50%', background: '#2a8a2a', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: '1px' }}>
                      <span style={{ color: '#fff', fontSize: '12px', fontWeight: '800' }}>✓</span>
                    </div>
                    <div>
                      <div style={{ fontSize: '12px', fontWeight: '800', color: '#222', marginBottom: '2px' }}>Purchase Shipping Label</div>
                      <div style={{ fontSize: '11px', color: '#777', lineHeight: 1.4 }}>Buy a discounted, fully insured label in-app. Both traders ship directly.</div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', padding: '10px 0' }}>
                    <div style={{ width: '22px', height: '22px', borderRadius: '50%', border: '2px solid #c8981e', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: '1px' }}>
                      <span style={{ color: '#c8981e', fontSize: '10px', fontWeight: '800' }}>3</span>
                    </div>
                    <div>
                      <div style={{ fontSize: '12px', fontWeight: '800', color: '#222', marginBottom: '2px' }}>Leave Feedback</div>
                      <div style={{ fontSize: '11px', color: '#777', lineHeight: 1.4 }}>Rate your trader and enjoy your next favorite pedal.</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </QuickstartPage>

          </div>
        </div>

        {/* Footer */}
        <div
          className="onboarding-quickstart-footer"
          style={{
            background: '#faf8f3', borderTop: '1px solid #e4dcc8',
            padding: '11px 20px',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between'
          }}
        >
          <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
            {[1, 2, 3, 4, 5].map(n => (
              <button key={n} type="button" onClick={() => setPage(n)} style={{
                width: '8px', height: '8px', borderRadius: '50%',
                background: page === n ? '#c8981e' : '#ddd4b0',
                border: 'none', padding: 0, cursor: 'pointer'
              }} aria-label={`Go to page ${n}`} />
            ))}
          </div>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            {page > 1 && (
              <button type="button" className="quickstart-nav-btn" onClick={() => setPage(p => p - 1)} style={{
                background: '#fff', border: '1px solid #ccc', borderRadius: '9999px',
                padding: '6px 13px', fontSize: '12px', fontWeight: '600', color: '#555', cursor: 'pointer'
              }}>Back</button>
            )}
            {page < 5 ? (
              <button type="button" className="quickstart-nav-btn" onClick={() => setPage(p => p + 1)} style={{
                background: '#c8981e', border: 'none', borderRadius: '9999px',
                padding: '6px 18px', fontSize: '12px', fontWeight: '700', color: '#fff', cursor: 'pointer'
              }}>Next</button>
            ) : (
              <button type="button" className="quickstart-nav-btn" onClick={() => {
                onClose();
                navigate(auth.currentUser ? '/addpedal' : '/signup');
              }} style={{
                background: '#c8981e', border: 'none', borderRadius: '9999px',
                padding: '6px 18px', fontSize: '12px', fontWeight: '700', color: '#fff', cursor: 'pointer'
              }}>{auth.currentUser ? 'List a Pedal' : 'Get Started'}</button>
            )}
          </div>
        </div>

      </div>
    </div>
    </>
  );
};

export default OnboardingQuickstartModal;
